<template>
  <table>
    <thead class="text-center">
      <td>신청일</td>
      <td>신청금액</td>
      <td>이자율</td>
      <td>수수료율</td>
      <td>상환비율</td>
      <td>상환기간</td>
      <td>대출</td>
      <td>상태</td>
    </thead>
    <tr v-for="(item, index) in inItems" :key="index">
      <td class="text-center">
        <router-link :to="`/woori-crowd/${item.uuid}`">{{
          $moment(item.created).format('YYYY-MM-DD HH:MM')
        }}</router-link>
      </td>
      <td class="text-right">{{ commaFormat(item.amount) }}</td>
      <td class="text-right">{{ item.interestRate }}</td>
      <td class="text-right">{{ item.commissionRate }}</td>
      <td class="text-right">{{ item.repaymentRatio }}</td>
      <td class="text-right">{{ item.repaymentPeriodInDays }}</td>
      <td class="text-right">
        <template v-if="!item.loanId"> - </template>
        <router-link v-else :to="{ name: 'loan/detail', params: { uuid: item.loanUuid } }">{{
          item.loanId
        }}</router-link>
      </td>
      <td class="text-right">{{ item.status | code('LoansRequest.Status') }}</td>
    </tr>
  </table>
</template>

<script>
import { defaultApi } from '@/plugins/api/defaultApi'
import { commaFormat } from '@/filter/number'

export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      inItems: [],
    }
  },
  async created() {
    this.inItems = await Promise.all(
      this.items.map(async (r) => {
        let loanUuid
        if (r.loanId) {
          const { data } = await defaultApi.getLoansRequestLoan(r.uuid)
          loanUuid = data.uuid
        }
        return {
          ...r,
          loanUuid,
        }
      }),
    )
  },
  methods: {
    commaFormat,
    async getLoanUuid(loan) {
      if (!loan.loanId) {
        return '-'
      }
      const { data } = await defaultApi.getLoansRequestLoan(this.uuid)
      return data.uuid
    },
  },
}
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
  td {
    border: 1px solid #aeaeae;
    padding: 2px 6px;
    font-size: 13px;
  }
}
</style>
